var _jsxFileName = "/repo/packages/webassets/src/components/SessionTimeoutModal/SessionTimeoutModal.js",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { defineMessages, T, t } from '@sm/intl';
import PropTypes from 'prop-types';
import { IconLock } from '@wds/icons';
import { Modal } from '@wds/modal';
import { Button } from '@wds/button';
import { Grid } from '@wds/grid';
import { useTheme } from 'react-jss';
import SessionCtrl from './SessionCtrl';
import useStyles from './useStyles';
import { WebAssetsThemeWrapper } from '../../theme';
var COPY = defineMessages({
  CONTINUE_SESSION: {
    id: 'SessionTimeoutModal.ContinueSession',
    defaultMessage: 'CONTINUE SESSION',
    description: '[Type: Button][Vis.: med] - CTA for the user to continue their browsing session and not be logged out automatically.'
  },
  TIME_LEFT_MSG: {
    id: 'SessionTimeoutModal.TimeLeftMessage',
    defaultMessage: 'After {minutesLeft, plural, one { 1 minute } other {{ minutesLeft } minutes}} of inactivity, we sign you out to keep your data safe. Your session will expire soon, unless you click <i>Continue Session</i>',
    description: '[Type: Paragraph][Vis.: med] - Message given to the user informing them of the time left before automatic expiration.'
  },
  SESSION_HEADER: {
    id: 'SessionTimeoutModal.TimeLeftHeader',
    defaultMessage: 'Do you want to continue your session?',
    description: '[Type: Header][Vis.: med] - Modal header for the prompt asking the user if they want to continue their browsing session.'
  }
});
var SessionTimeoutModal = function SessionTimeoutModal(props) {
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(SessionTimeoutModalContent, Object.assign({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  })));
};
var SessionTimeoutModalContent = function SessionTimeoutModalContent(_ref) {
  var user = _ref.user;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    timeLeft = _useState4[0],
    setTimeLeft = _useState4[1];
  var theme = useTheme();
  var _useStyles = useStyles({
      theme: theme
    }),
    iconBackground = _useStyles.iconBackground;
  var onReminder = function onReminder(timeRemaining) {
    setShow(true);
    setTimeLeft(timeRemaining);
  };
  var onClose = function onClose() {
    SessionCtrl.continueSession(function () {
      setShow(false);
      setTimeLeft(0);
    });
  };
  useEffect(function () {
    var timeout = user && (user.hipaa && user.hipaa.isHipaaEnabled && 30 * 60 || user.group && user.group.sessionTimeout && parseInt(user.group.sessionTimeout, 10) * 60);
    if (timeout !== undefined) {
      // it could be 0
      SessionCtrl.init({
        timeout: timeout,
        reminderCb: onReminder
      });
    }
    return function cleanup() {
      SessionCtrl.removeCallback();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onClose: onClose,
    className: "sm-session-timeout-modal-container",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    header: t(COPY.SESSION_HEADER),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Modal.Body, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    noBleeds: true,
    noGutters: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    xs: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: iconBackground,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(IconLock, {
    title: "SessionTimeoutIcon",
    color: "light",
    size: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement(Grid.Item, {
    xs: 9,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.TIME_LEFT_MSG,
    values: {
      minutesLeft: timeLeft
    },
    html: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 13
    }
  })))), /*#__PURE__*/React.createElement(Modal.Footer, {
    align: "right",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: onClose,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.CONTINUE_SESSION,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 11
    }
  }))));
};
SessionTimeoutModalContent.propTypes = {
  user: PropTypes.shape({
    hipaa: PropTypes.shape({
      isHipaaEnabled: PropTypes.bool
    }),
    group: PropTypes.shape({
      sessionTimeout: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  }).isRequired
};
export default SessionTimeoutModal;
//# sourceMappingURL=SessionTimeoutModal.js.map